<template>
  <b-form-group
    label="Tavsiye Edilen Birim Satış Fiyatı"
    label-for="unit_sale"
  >
    <validation-provider
      #default="{ errors }"
      name="Tavsiye Edilen Birim Satış Fiyatı"
      rules="required"
    >
      <cleave
        id="unit_sale"
        v-model="dataItem.unit_sale"
        class="form-control"
        :raw="true"
        :options="options.number"
        placeholder="Satış Fiyatı"
      />
      <small
        v-if="!errors[0]"
        class="text-muted"
      >(KDV Hariç Tutar)</small>
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import { required } from '@validations'
import Cleave from 'vue-cleave-component'
import {
  BFormGroup,
} from 'bootstrap-vue'

export default {
  name: 'UnitSale',
  components: {
    Cleave,
    ValidationProvider,
    BFormGroup,
  },
  data() {
    return {
      required,
      options: {
        number: {
          numeral: true,
        },
      },
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['servicePrices/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>
